import { Route, Switch } from "react-router-dom";
import { RouteBankingVerification } from "./routes/RouteBankingVerificaiton";
import { RouteChange } from "./routes/RouteChange";
import { RoutePayeeOnboarding } from "./routes/RoutePayeeOnboarding";
import { RoutePayerOnboarding } from "./routes/RoutePayerOnboarding";
import { RouteTaxPayeeOnboarding } from "./routes/RouteTaxPayeeOnboarding";
import { RouteTaxPayerOnboarding } from "./routes/RouteTaxPayerOnboarding";
import { RouteTaxVerificaiton } from "./routes/RouteTaxVerificaiton";
import { RouteTaxWithholdings } from "./routes/RouteTaxWithholdings";
import { RouteUsPersonInfo } from "./routes/RouteUsPersonInfo";

export const PATH_ONBOARDING = "/member/onboarding";
export const PATH_ONBOARDING_PAYER = PATH_ONBOARDING + "/payer";
export const PATH_ONBOARDING_PAYEE = PATH_ONBOARDING + "/payee";
export const PATH_ONBOARDING_TAX_PAYEE = PATH_ONBOARDING + "/tax-payee";
export const PATH_ONBOARDING_TAX_PAYER = PATH_ONBOARDING + "/tax-payer";
export const PATH_ONBOARDING_TAX_WITHHOLDINGS =
  PATH_ONBOARDING + "/tax-withholdings";
export const PATH_ONBOARDING_VERIFICAIONS_TAX =
  PATH_ONBOARDING + "/verifications/tax";
export const PATH_ONBOARDING_VERIFICAIONS_BANKING =
  PATH_ONBOARDING + "/verifications/banking";
export const PATH_ONBOARDING_CHANGE = PATH_ONBOARDING + "/change";
export const PATH_ONBOARDING_US_PERSON_INFO =
  PATH_ONBOARDING + "/us-person-info";

export const PATH_ONBOARDING_PAYEE_REQUIREMENT_DETAILS =
  PATH_ONBOARDING_PAYEE + "/requirements/:requirementId/details";

export const Onboarding = () => (
  <Switch>
    <Route path={PATH_ONBOARDING_PAYER} component={RoutePayerOnboarding} />

    <Route path={PATH_ONBOARDING_PAYEE} component={RoutePayeeOnboarding} />

    <Route
      path={PATH_ONBOARDING_TAX_PAYEE}
      component={RouteTaxPayeeOnboarding}
    />

    <Route
      path={PATH_ONBOARDING_TAX_PAYER}
      component={RouteTaxPayerOnboarding}
    />

    <Route
      path={PATH_ONBOARDING_TAX_WITHHOLDINGS}
      component={RouteTaxWithholdings}
    />

    <Route
      path={PATH_ONBOARDING_VERIFICAIONS_TAX}
      component={RouteTaxVerificaiton}
    />

    <Route
      path={PATH_ONBOARDING_VERIFICAIONS_BANKING}
      component={RouteBankingVerification}
    />

    <Route
      path={PATH_ONBOARDING_US_PERSON_INFO}
      component={RouteUsPersonInfo}
    />

    <Route path={PATH_ONBOARDING_CHANGE} component={RouteChange} />
  </Switch>
);
